import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
// import axios from "@/config/axios";
import vuetify from "./plugins/vuetify";
import VueGtag from "vue-gtag";

// axios.setup();

Vue.config.productionTip = false;

if (
  process.env.VUE_APP_LOCATION === "oosterwolde" &&
  process.env.VUE_APP_ENV === "production"
) {
  Vue.use(
    VueGtag,
    {
      config: { id: "G-TBSME652T4" }
    },
    router
  );
} else if (
  process.env.VUE_APP_LOCATION === "apeldoorn" &&
  process.env.VUE_APP_ENV === "production"
) {
  Vue.use(
    VueGtag,
    {
      config: { id: "G-HWQ28M1BDZ" }
    },
    router
  );
} else if (
  process.env.VUE_APP_LOCATION === "alkmaar" &&
  process.env.VUE_APP_ENV === "production"
) {
  Vue.use(
    VueGtag,
    {
      config: { id: "G-XW96E76WT1" }
    },
    router
  );
}

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
